import { useTranslation } from "react-i18next"
import { Button } from "@nexus/ui"

import type { PersonasOnboardingCardVariant } from "./persona-onboarding-card.types"

/**
 * Dormant mirror of the focused action row for peek cards.
 * Uses the same `Button` chrome so side cards don’t look like inputs / collapsed chips.
 * Non-interactive — the card shell handles focus via `onFocus`.
 */
export function PeekActions({ variant }: { variant: PersonasOnboardingCardVariant }) {
  const { t } = useTranslation()
  if (variant === "industry") {
    return (
      <div className="pointer-events-none flex items-center gap-2 opacity-45" aria-hidden>
        <Button type="button" variant="outline" size="lg" tabIndex={-1} className="min-w-0 flex-1" iconStart="x">
          {t("personas.onboarding.industry.reject", "Reject")}
        </Button>
        <Button
          type="button"
          size="lg"
          tabIndex={-1}
          className="min-w-0 flex-1 bg-[var(--competitor)] text-white hover:bg-[var(--competitor)]"
          iconStart="plus"
        >
          {t("personas.onboarding.industry.accept", "Add persona")}
        </Button>
      </div>
    )
  }
  return (
    <div className="pointer-events-none flex flex-wrap items-center gap-2 opacity-45" aria-hidden>
      <Button
        type="button"
        variant="outline"
        size="lg"
        tabIndex={-1}
        className="min-w-0 flex-1 border-error/40 text-error hover:border-error/40 hover:bg-transparent hover:text-error"
        iconStart="x"
      >
        {t("personas.onboarding.review.reject", "Reject")}
      </Button>
      <Button type="button" size="lg" tabIndex={-1} className="min-w-0 flex-1" iconStart="check">
        {t("personas.onboarding.review.accept", "Accept")}
      </Button>
    </div>
  )
}
